import {UPDATE_BUDGET} from './actions';

export function budget(state: BudgetState, {type, payload}: Action): BudgetState {
  switch (type) {
    case UPDATE_BUDGET:
      return {...(payload as BudgetState)};

    default:
      return state;
  }
}
